/**
 * «ÅPNE BJELLA» FRA ET ANNET STED (276.10).
 *
 * Bjella er det eneste stedet man får varsler. Det som før sendte til Innboks › Varsler — toasten
 * om en nevning, og gamle lenker med `?view=notifications` — ber nå bjella åpne seg.
 *
 * FORESPØRSELEN BLIR LIGGENDE til bjella har hentet den. Innboksen kan be om det i sin første
 * effekt, før toppen har rukket å lytte; uten et flagg ville den forespørselen blitt borte.
 */
type Listener = () => void;

const listeners = new Set<Listener>();
let pending = false;

export function requestBellOpen(): void {
  if (listeners.size === 0) {
    pending = true;
    return;
  }
  for (const listener of listeners) listener();
}

/** Bjella lytter. En forespørsel som kom før den lyttet, leveres med en gang. */
export function subscribeBellOpen(listener: Listener): () => void {
  listeners.add(listener);
  if (pending) {
    pending = false;
    listener();
  }
  return () => {
    listeners.delete(listener);
  };
}
